import { CustomerGroupResponse } from "@/models/response/customerGroup";
import { IconChevronLeft, IconDotsVertical, IconSend, IconUserPlus, IconUsers } from "@tabler/icons-react";
import { createdLabel, faNumber } from "./sms";
import classes from "./sms.module.scss";

type Props = {
  group: CustomerGroupResponse;
  onOpen: () => void;
  onSend: () => void;
  onAdd: () => void;
  onMenu: () => void;
};

export default function GroupCard({ group, onOpen, onSend, onAdd, onMenu }: Props) {
  const count = group.membersCount ?? 0;
  const empty = count === 0;
  const created = createdLabel(group.creationTime);
  return (
    <article className={classes.groupCard} data-empty={empty}>
      <button type="button" className={classes.groupLink} onClick={onOpen}>
        <span className={classes.groupIcon} data-empty={empty}>
          <IconUsers size={23} stroke={1.8} aria-hidden />
        </span>
        <span className={classes.groupText}>
          <span className={classes.groupName}>{group.name}</span>
          {group.description && <span className={classes.groupDesc}>{group.description}</span>}
          <span className={classes.groupMeta}>
            {empty ? "هنوز عضوی ندارد" : <strong>{faNumber(count)} عضو</strong>}
            {created && `، ${created}`}
          </span>
        </span>
        {!empty && <IconChevronLeft className={classes.chevron} size={20} stroke={1.8} aria-hidden />}
      </button>
      <div className={classes.groupActions}>
        {empty ? (
          <button type="button" className={classes.softButton} style={{ background: "#424e88", color: "#ffffff" }} onClick={onAdd}>
            <IconUserPlus size={18} stroke={1.8} aria-hidden />
            افزودن اولین اعضا
          </button>
        ) : (
          <>
            <button type="button" className={classes.softButton} onClick={onSend}>
              <IconSend size={18} stroke={1.8} aria-hidden />
              ارسال پیامک
            </button>
            <button type="button" className={classes.outlineButton} onClick={onAdd}>
              <IconUserPlus size={18} stroke={1.8} aria-hidden />
              افزودن عضو
            </button>
          </>
        )}
        <button type="button" className={classes.iconButton} style={{ borderRadius: 12 }} aria-label={`گزینه‌های گروه ${group.name ?? ""}`} onClick={onMenu}>
          <IconDotsVertical size={22} stroke={1.8} />
        </button>
      </div>
    </article>
  );
}
